<template>
	<nav class="desk-tabs" aria-label="Abas abertas">
		<div class="desk-tabs-lista" role="tablist">
			<button
				v-for="tab in tabsStore.tabs"
				:key="tab.id"
				type="button"
				role="tab"
				class="desk-tab"
				:class="{ 'desk-tab--ativa': tab.path === tabsStore.activePath }"
				:aria-selected="tab.path === tabsStore.activePath"
				:title="tab.label"
				@click="tabsStore.ativar(tab.path)"
			>
				<span class="desk-tab-rotulo">{{ tab.label }}</span>
				<span
					v-if="tab.closable"
					class="desk-tab-fechar"
					role="button"
					aria-label="Fechar aba"
					title="Fechar"
					@click.stop="tabsStore.fechar(tab.path)"
				>
					<i class="pi pi-times" aria-hidden="true" />
				</span>
			</button>
		</div>
	</nav>
</template>

<script lang="ts" setup>
	import { useDesktopTabsStore } from "~/store/tabs/desktopTabs.store";

	const tabsStore = useDesktopTabsStore();
</script>

<style scoped>
	.desk-tabs {
		width: 100%;
		border-bottom: 1px solid color-mix(in srgb, currentColor 12%, transparent);
		background: color-mix(in srgb, currentColor 3%, transparent);
		margin: 0 0 0.35rem;
	}

	.desk-tabs-lista {
		display: flex;
		flex-wrap: nowrap;
		gap: 0.15rem;
		overflow-x: auto;
		padding: 0.35rem 0.5rem 0;
		scrollbar-width: thin;
	}

	.desk-tab {
		display: inline-flex;
		align-items: center;
		gap: 0.4rem;
		max-width: 16rem;
		padding: 0.45rem 0.7rem 0.5rem;
		border: 1px solid transparent;
		border-bottom: none;
		border-radius: 8px 8px 0 0;
		background: transparent;
		color: inherit;
		font: inherit;
		font-size: 0.85rem;
		font-weight: 600;
		cursor: pointer;
		opacity: 0.72;
		white-space: nowrap;
	}

	.desk-tab:hover {
		opacity: 1;
		background: color-mix(in srgb, currentColor 6%, transparent);
	}

	.desk-tab--ativa {
		opacity: 1;
		background: var(--surface-card, #fff);
		border-color: color-mix(in srgb, currentColor 14%, transparent);
		box-shadow: 0 -1px 0 var(--surface-card, #fff);
	}

	.desk-tab-rotulo {
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.desk-tab-fechar {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 1.25rem;
		height: 1.25rem;
		border-radius: 50%;
		font-size: 0.7rem;
		opacity: 0.7;
	}

	.desk-tab-fechar:hover {
		opacity: 1;
		background: color-mix(in srgb, #c0392b 18%, transparent);
		color: #c0392b;
	}
</style>
